import React, { PropsWithChildren } from 'react';

import { WalkthroughContextProvider } from '../context';
import { UnAnchoredBlurbRenderer } from './UnanchoredBlurbRenderer';

export function WalkthroughProvider(props: PropsWithChildren) {
  return (
    <WalkthroughContextProvider>
      {props.children}
      <UnAnchoredBlurbRenderer />
    </WalkthroughContextProvider>
  );
}
